import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

export interface AccountSidebarProps {
  /** 当前选中的菜单路径 */
  activePath?: string;
  /** 外部传入的样式类名 */
  className?: string;
  /** 是否展示顶部当前账号概览卡片 */
  showUserCard?: boolean;
}

export const AccountSidebar: React.FC<AccountSidebarProps> = ({
  activePath,
  className = '',
  showUserCard = true,
}) => {
  const location = useLocation();
  const currentPath = activePath || location.pathname;
  const { user, can, isEnterprise } = useAuth();

  const sidebarLinks = [
    { label: '主体资料', href: '/profile', icon: 'ri-user-3-line', visible: true },
    {
      label: isEnterprise ? '企业档案' : '个人档案',
      href: '/provider-profile',
      icon: 'ri-user-star-line',
      visible: true,
    },
    {
      label: isEnterprise ? '企业认证' : '实名认证',
      href: '/certification',
      icon: 'ri-shield-check-line',
      visible: true,
    },
    {
      label: '我的求职',
      href: '/my-job-resume',
      icon: 'ri-briefcase-line',
      visible: !isEnterprise,
    },
    // {
    //   label: '我的简历',
    //   href: '/my-resume',
    //   icon: 'ri-file-user-line',
    //   visible: !isEnterprise,
    // },
    {
      label: '我的需求',
      href: isEnterprise ? '/my-postings' : '/my-bids',
      icon: 'ri-survey-line',
      visible: isEnterprise ? (can ? can('demand:manage-own') : true) : true,
    },
    {
      label: '招聘管理',
      href: '/my/job-postings',
      icon: 'ri-user-search-line',
      visible: isEnterprise,
    },
    // { label: '我的订单', href: '/orders', icon: 'ri-file-text-line', visible: true },
    { label: '服务工单', href: '/support-tickets', icon: 'ri-customer-service-2-line', visible: true },
    { label: '积分流水', href: '/point-transactions', icon: 'ri-coins-line', visible: true },
    { label: '收益管理', href: '/revenue', icon: 'ri-money-cny-circle-line', visible: true },
    { label: '结算资料', href: '/billing-profile', icon: 'ri-bank-card-line', visible: true },
    { label: '合同文件', href: '/contracts', icon: 'ri-file-text-line', visible: true },
    { label: '安全设置', href: '/settings', icon: 'ri-lock-line', visible: true },
  ].filter((item) => item.visible);

  return (
    <aside className={`lg:w-56 flex-shrink-0 ${className}`}>
      <div className="glass-card rounded-2xl p-4 space-y-1">
        {showUserCard && user && (
          <div className="px-4 pb-4 mb-2 border-b border-background-200">
            <p className="text-xs text-foreground-400">当前账号</p>
            <p className="text-sm font-semibold text-foreground-900 mt-1 truncate">{user.name}</p>
            <p className="text-xs text-foreground-400 mt-0.5">{isEnterprise ? '企业账号' : '个人账号'}</p>
          </div>
        )}
        {sidebarLinks.map((link) => {
          const isActive = currentPath === link.href;
          return (
            <Link
              key={link.href}
              to={link.href}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm transition-all cursor-pointer ${isActive
                ? 'bg-primary-100 text-primary-700 font-medium'
                : 'text-foreground-600 hover:bg-gray-50'
                }`}
            >
              <i className={`${link.icon} text-base w-4`} aria-hidden="true"></i>
              {link.label}
            </Link>
          );
        })}
      </div>
    </aside>
  );
};

export default AccountSidebar;
